import { appendParams, convertToTimeDropDownValue, dateTimePayloadFormetter, useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import { LmsTimeDropdownOptions } from "../../constants/GlobalConstants";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import LmsTabPages from "../ui/LmsTabPages";

const MainTable = () => {
  const actionButtons = ["add", "edit", "remove", "export"];
  return <LmsTable 
    actionButtons={actionButtons} 
    apiSuffix="inspections/company-draw-funded" 
    deleteSuffix="inspections/company-draw-funded"
  />;
};

const LmsInspectionDrawFundedDocumentTable = ({ drawFundedId, drawFundedDocumentLogId = "", suffix = "" }) => {
  const editPath = appendParams("inspections-inspection-company-draw-funded/editdocument/{id}", [{ drawFundedId }, { drawFundedDocumentLogId }]);
  const actionsButtons = [
    {
      text: "Add",
      path: `/inspections-inspection-company-draw-funded/adddocument?drawfundedid=${drawFundedId}`,
    },
    {
      text: "Edit",
      path: editPath,
      isDisabled: (checkedItems) => checkedItems?.length !== 1,
    },
    "remove",
    "export",
  ];

  return (
    <LmsTable
      actionButtons={actionsButtons}
      apiSuffix={suffix ? suffix : `inspections/draw-funded-document-logs/${drawFundedId}`}
      deleteSuffix="inspections/draw-funded-document-logs"
      sortable={["Name"]}
      onClickPath={editPath}
      useGlobalDictionary
    />
  );
};

const inspectionCompanyDrawFundedFormFields = (myForm) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Loan Draw", "inspections/list-loan-draws", { name: "loanDrawId", required: true }),
    myForm.getDropdownField("Inspection Company Inspection", "inspections/list-nwcc-inspection", {
      name: "nwccinspectionId",
      required: true,
    }),
  ]);
  // TODO: check Sprint Work 14927 for downloading document endpoint
  myForm.addCenteredGroup([myForm.getFileField("Document", { value: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Document File Name", { field: "textarea" })]);
  myForm.addCenteredGroup([
    myForm.getCalendarField("Submitted On Date", { name: "submittedOn" }),
    myForm.getDropdownField("Submitted On Time", LmsTimeDropdownOptions, { value: convertToTimeDropDownValue(myForm?.initialValues.submittedOn) }),
  ]);
  myForm.addCenteredGroup([
    myForm.getCalendarField("Completed On Date", { name: "completedOn" }),
    myForm.getDropdownField("Completed On Time", LmsTimeDropdownOptions, { value: convertToTimeDropDownValue(myForm?.initialValues.completedOn) }),
  ]);

  myForm.addCenteredGroup([myForm.getInputField("Error Message", { field: "textarea" })]);
  
  return myForm;
};

const inspectionCompanyDrawFundedDocumentFormFields = (myForm) => {
  myForm.addCenteredGroup([
    myForm.getDisplayField("Inspection Company Draw Funded", { name: "nwccDrawFundedDisplay" }), 
    myForm.getDropdownField("Inspection Company Inspection Document Log", "inspections/list-inspection-document-log", { 
      name: "nwccinspectionDocumentLogId",
      required: true,
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Document Log", "inspections/list-document-log", { name: "documentLogId" })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Name")
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Submitted On Date", { name: "submittedOn" }),
    myForm.getDropdownField("Submitted On Time", LmsTimeDropdownOptions, { value: convertToTimeDropDownValue(myForm?.initialValues.submittedOn) }),
  ]);

  myForm.addCenteredGroup([myForm.getInputField("Error Message", { field: "textarea" })]);
  
  return myForm;
};

const EditInspectionCompanyDrawFundedForm = ({ id }) => {
  const [{ data: drawFundedData, isLoading, error }] = useFetchData(`inspections/draw-funded/${id}`);
  const tabPages = {
    "Document Log": <LmsInspectionDrawFundedDocumentTable drawFundedId={id} suffix={`inspections/draw-funded-document-logs/${id}`} />,
  };

  const myForm = inspectionCompanyDrawFundedFormFields(
    new BCFormController(drawFundedData, { 
      submitSuffix: "inspections/company-draw-funded", 
      submitMethod: "PUT",
      clearSuffixesOnSubmit: [`inspections/draw-funded/${id}`],
      payloadDataType: "FormData",
      dataFormatterFunc: (data) => { return {
        ...data, 
        submittedOn: dateTimePayloadFormetter(data?.submittedOn, data.submittedOnTimeId), 
        completedOn: dateTimePayloadFormetter(data?.completedOn, data.completedOnTimeId)  
      }; },
      blankWidth: 4 
    })
  );

  const formActions = ["save", "save-close", "delete", "close"];
  return (<>
    <LmsFormGenerator myForm={myForm} actions={formActions} isLoading={isLoading} error={error} />
      {tabPages && <LmsTabPages tabPages={tabPages}/>}
    </>
  );
};

const EditInspectionCompanyDrawFundedDocumentForm = ({ id }) => {
  const [{ data: companyDrawFundedDocumentData, isLoading, error }] = useFetchData(`inspections/draw-funded-document-log/${id}`);
  const myForm = inspectionCompanyDrawFundedDocumentFormFields(
    new BCFormController(companyDrawFundedDocumentData, { 
      submitSuffix: "inspections/draw-funded-document-log", 
      submitMethod: "PUT", 
      clearSuffixesOnSubmit: [`inspections/draw-funded-document-log/${id}`],
      deleteSuffix: "inspections/draw-funded-document-logs", // TODO: Sprint Work 14930
      dataFormatterFunc: (data) => { return {
        ...data, 
        id: id, 
        nwccdrawFundedId: companyDrawFundedDocumentData?.nwccdrawFundedId,
        ...(data?.submittedOn ? { submittedOn: dateTimePayloadFormetter(data?.submittedOn, data?.submittedOnTimeId )} : {})
      }; },
      blankWidth: 4 
    })
  );

  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
    />
  );
};

const AddInspectionCompanyDrawFundedForm = () => {
  const myForm = inspectionCompanyDrawFundedFormFields(
    new BCFormController({}, { 
      submitSuffix: "inspections/company-draw-funded", 
      submitMethod: "POST", 
      payloadDataType: "FormData",
      dataFormatterFunc: (data) => { return {
        ...data, 
        submittedOn: dateTimePayloadFormetter(data?.submittedOn, data.submittedOnTimeId), 
        completedOn: dateTimePayloadFormetter(data?.completedOn, data.completedOnTimeId)  
      }; },
      blankWidth: 4 
    })
  );

  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} />;
};

const AddInspectionCompanyDrawFundedDocumentForm = ({ id }) => {
  const [{ data: drawFundedData, isLoading, error }] = useFetchData(`inspections/draw-funded/${id}`);
  const myForm = inspectionCompanyDrawFundedDocumentFormFields(
    new BCFormController({ nwccDrawFundedDisplay: drawFundedData?.display }, { 
      submitSuffix: "inspections/draw-funded-document-log", 
      submitMethod: "POST",
      dataFormatterFunc: (data) => { return {
        ...data, 
        nwccdrawFundedId: id,
        ...(data?.submittedOn ? { submittedOn: dateTimePayloadFormetter(data?.submittedOn, data?.submittedOnTimeId )} : {})
      }; },
      blankWidth: 4
    })
  );

  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} isLoading={isLoading} error={error} />;
};

const LmsInspectionsInspectionCompanyDrawFunded = ({
  params = {},
  history,
}) => {
  const allowedActions = ["add", "edit"];
  const inspectionDrawSubpages = ["adddocument", "editdocument"];
  const allowedSubpages = [...inspectionDrawSubpages] as any[];
  const { isMainPage, isAdd, isEdit, isActionAllowed, isSubpageAllowed, actionLower, id, query } =
  useParseRouteActions(params, allowedActions, allowedSubpages);
  const drawfundedId = query.get("drawfundedid") || "";
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isAdd && <AddInspectionCompanyDrawFundedForm />}
      {isEdit && <EditInspectionCompanyDrawFundedForm id={id} />}
      {isSubpageAllowed && (
        <>
          {actionLower === "adddocument" && (
            <AddInspectionCompanyDrawFundedDocumentForm id={drawfundedId} />
          )}
          {actionLower === "editdocument" && (
            <EditInspectionCompanyDrawFundedDocumentForm id={id} />
          )}
        </>
      )}
    </>
  );
};

export default LmsInspectionsInspectionCompanyDrawFunded;
